import { SwitchWithLabel } from "@/core/components/switch-with-label";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { SectionHeading, SectionLabel } from "@/accounts-payable/common";
import type {
  ApVendor,
  ApVendorUpdate,
  ApVendorListEdit,
} from "@/accounts-payable/types";
import { EditableChips } from "./editable-chips";

export const IncomingEmailSection = ({
  vendor,
  onUpdate,
  onEditList,
}: {
  vendor: ApVendor;
  onUpdate: (changes: ApVendorUpdate) => void;
  onEditList: (edit: ApVendorListEdit) => void;
}) => (
  <Stack gap="sm" fullWidth>
    <SectionHeading>Incoming email</SectionHeading>
    <SwitchWithLabel
      label="Process emails from this vendor"
      aria-label="Process emails from this vendor"
      checked={vendor.active}
      onChange={(active) => onUpdate({ active })}
    />
    <SectionLabel>Email aliases</SectionLabel>
    <Typography variant="captionW1" textColor="tertiary">
      Invoices from these addresses are recognized as this vendor.
    </Typography>
    <EditableChips
      values={vendor.email_aliases ?? []}
      noun="address"
      placeholder="name@vendor.com"
      onAdd={(value) =>
        onEditList({ field: "email_aliases", action: "add", value })
      }
      onRemove={(value) =>
        onEditList({ field: "email_aliases", action: "remove", value })
      }
    />
  </Stack>
);
